if (!customElements.get('card-color-preview')) {
  customElements.define('card-color-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.request = 0;
      this.addEventListener('click', (event) => {
        const more = event.target.closest('[data-show-colors]');
        if (more) {
          this.querySelectorAll('[data-extra-color]').forEach(button => { button.hidden = false; });
          more.setAttribute('aria-expanded', 'true');
          const firstExtra = this.querySelector('[data-extra-color]');
          more.hidden = true;
          if (firstExtra) firstExtra.focus();
          return;
        }
        const button = event.target.closest('[data-color-preview]');
        if (!button || !this.contains(button)) return;
        event.preventDefault();
        const card = this.closest('.product-card-wrapper');
        const image = card?.querySelector('.card__media .media > img');
        if (!card || !image) return;
        const request = ++this.request;
        const next = new Image();
        button.setAttribute('aria-busy', 'true');
        next.onload = () => {
          button.removeAttribute('aria-busy');
          if (request !== this.request || !this.isConnected) return;
          card.setAttribute('data-swatch-selected', '');
          image.srcset = button.dataset.srcset;
          image.src = button.dataset.image;
          image.alt = this.dataset.productName + ' — ' + button.dataset.color;
          card.querySelectorAll('.card__heading a[href]').forEach(link => { link.href = button.dataset.productUrl; });
          card.querySelectorAll('[data-product-url]').forEach(control => {
            if (!control.closest('card-color-preview')) control.dataset.productUrl = button.dataset.productUrl;
          });
          this.querySelectorAll('[data-color-preview]').forEach(chip => chip.setAttribute('aria-pressed', String(chip === button)));
          this.querySelector('.sjbjj-color-label').textContent = button.dataset.color;
        };
        next.onerror = () => { button.removeAttribute('aria-busy'); };
        next.src = button.dataset.image;
      });
    }
  });
}